import _ from 'lodash';

export const VueLodash = {
    install(app) {
        app.config.globalProperties.$lodash = () => {
            return _;
        };
    }
}
